import { type ListTranscriptSegmentsResponse } from '@air/api';

import { type TranscriptSegmentType } from '~/components/AssetModal/shared/components/TranscriptPanel/types';
import { type DataForTimeInterval } from '~/swr-hooks/clips/transcript/utils/getDataForTimeInterval';

export type ClipTranscriptCache = {
  data: DataForTimeInterval<TranscriptSegmentType>[];
  hasMore: boolean;
};

export type TranscriptsSegmentPagination = ListTranscriptSegmentsResponse['pagination'];
export type TimeBasedPagination = {
  previousEndTimeMs: number | null;
  nextStartTimeMs: number | null;
};

export type TimeRange = {
  startTimeMs: number;
  endTimeMs: number;
};

export const isTimeBasedPagination = (pagination: TranscriptsSegmentPagination): pagination is TimeBasedPagination =>
  'nextStartTimeMs' in pagination && 'previousEndTimeMs' in pagination;
